// @ts-nocheck
import {
  Box,
  Card,
  Checkbox,
  ClickAwayListener,
  Fade,
  FormControl,
  FormControlLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  styled,
} from "@mui/material";
import Header from "../../partials/header";
import LeftSidebar from "../../partials/leftSidebar";
import searchIcon from "../../../assets/images/icon/search.svg";
import gridIcon from "../../../assets/images/icon/userGrid-view.svg";
import listIcon from "../../../assets/images/icon/userList-view.svg";
import phoneIcon from "../../../assets/images/icon/phoneIcon.svg";
import mailIcon from "../../../assets/images/icon/mailIcon.svg";
import threeDotsIcon from "../../../assets/images/icon/threedots.png";
import editIcon from "../../../assets/images/icon/edit.png";
import deleteIcon from "../../../assets/images/icon/delete.png";
import { makeStyles } from "@mui/styles";
import { useCallback, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import ProfileAvatar from "../../user/ProfileAvatar";
import AntSwitch from "../../sharedComponent/AntSwitch";
import UserCardGrid from "./UserCardGrid";
import closeIcon from "../../../assets/images/close.svg";
import PhoneInput from "react-phone-input-2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ActivateAndSuspenduser,
  addBulkPartnerUsers,
  deletePartnerUsers,
  getPartnerRoles,
  getPartnerUsers,
  updatePartnerUsers,
} from "../../../services/api/userRolesApi";
import { ToastContext, useToastContext } from "../../../context/toastContext";
import Loading from "../../loading";
import ConfirmationModal from "./ConfirmationModal";
import InfoHoverTooltip from "../../Tooltips/InfoHover";

const useStyles = makeStyles({
  toggleBtnsGrp: {
    border: "1px solid #5A5F60",
    borderRadius: "30px !important",
    "& .toggle-switch": {
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      background: "#1f2f34",
      borderRadius: "30px",
      padding: "6px 10px",
    },
  },
  formControl: {
    width: "100%",
    "& .MuiSelect-select": {
      backgroundColor: "#1F2F34",
      borderRadius: "30px",
      padding: "8px 20px 8px 16px",
      fontSize: "14px",
      fontWeight: 400,
      border: "1px solid #5A5F60",
      outline: "none",
      width: "100%",
      color: "#A5A8A9",
      "&:hover": {
        border: "1px solid #5A5F60",
      },
      "&:focus": {
        border: "1px solid #5A5F60",
        outline: "none",
        boxShadow: "none",
        borderRadius: "30px",
      },
      "&.MuiSelect-selectMenu": {
        "&:before, &:after": {
          display: "none",
        },
      },
    },
  },
  menuItem: {
    backgroundColor: "#1F2F34",
    borderRadius: "4px",
    fontSize: "14px",
    padding: "12px 16px",
    minWidth: "143px",
    "&:hover": {
      backgroundColor: "#0B4A62",
    },
  },
  selectedMenuItem: {
    backgroundColor: "#0B4A62",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#0B4A62",
    },
  },
  checkbox: {
    padding: 0,
    marginRight: "12px",
    "& .MuiSvgIcon-root": {
      fill: "#E2E3E3",
      height: "20px",
      width: "20px",
    },
    "&:hover .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-disabled": {
      fill: "currentColor",
      opacity: "0.3",
      cursor: "not-allowed",
    },
  },
  radio: {
    "& .MuiSvgIcon-root": {
      fill: "#E2E3E3",
      height: "20px",
      width: "20px",
    },
    "&:hover .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      fill: "#17B2EB",
    },
  },
  userTableBG: {
    background: "transparent !important",
    borderRadius: "50px",
  },
});

interface UserData {
  userId: string;
  profileId: number;
  superadmin: boolean;
  name: string;
  lastName: string;
  address: Address;
  mailId: string;
  mobile: string;
  sequrityQuestion1?: string;
  sequrityAnswer1?: string;
  sequrityQuestion2?: string;
  sequrityAnswer2?: string;
  lastLoginTime: number;
  logedId: boolean;
  machineUser: number;
  sites: any[];
  enterprises: any[];
  accountStatus: string;
  profilePhoto: string;
}

interface Address {
  state: string;
}

interface FormData {
  name: string;
  lastName: string;
  mailId: string;
  mobile: string;
  role: string;
  profileId: string;
  emailMessage: string;
}

const UsersTab = () => {
  const classes = useStyles();
  const { setToast } = useToastContext() as ToastContext;

  const [view, setView] = useState<"table" | "grid">("grid");
  const [activeTab, setActiveTab] = useState("grid");
  const [setData, setUserData] = useState<[]>([]);
  const [search, setSearch] = useState<string>("");
  const [dropdownVisible, setDropdownVisible] = useState<
    number | string | null
  >(null);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    mailId: "",
    mobile: "",
    profileId: 0,
    emailMessage: "",
    redirecturl: "",
  });
  const [editFormData, setEditFormData] = useState({
    name: "",
    lastName: "",
    mailId: "",
    mobile: "",
    profileId: 0,
    userId: "",
    redirecturl: "",
  });

  const [rolesVisible, setRolesVisible] = useState(false);
  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [checkedAllUser, setCheckedAllUser] = useState(false);
  const [checkedIds, setCheckedIds] = useState<string[]>([]);
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [selectedCount, setSelectedCount] = useState(0);
  const [activeUser, setActiveUser] = useState<{}>({});
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [loggedInUser, setIsloggedInUser] = useState<boolean>(false);
  const [activeModalTab, setActiveModalTab] = useState<string>("userDetails");
  const [allRoles, setAllRoles] = useState<[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [confirmationModalOpen, setConfirmationModalOpen] =
    useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [userDeleteId, setUserDeleteId] = useState<any>(null);
  const [userDataCopy, setUserDataCopy] = useState<[]>([])
  
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  type PhoneNumberState = {
    number: string;
    error: string;
  };

  const [phoneNumber, setPhoneNumber] = useState<PhoneNumberState>({
    number: "",
    error: "",
  });

  const validateForm = (data: any) => {
    let errors: Partial<FormData> = {};
    if (!data.name) {
      errors.name = "First name is required";
    }
    if (!data.lastName) {
      errors.lastName = "Last Name is required";
    }
    if (!data.mailId) {
      errors.mailId = "Email ID can't be empty";
    } else if (!emailPattern.test(data.mailId)) {
      errors.mailId = "Please provide correct email pattern";
    }
    if (!data.mobile) {
      errors.mobile = "Mobile number can't be empty";
    }

    // if (!data.emailMessage) {
    //   errors.emailMessage = "Email message can't be empty";
    // }
    return errors;
  };

  const handleTabClick = (tabName: string) => {
    if (tabName !== activeTab) {
      setActiveTab(tabName);
    }
  };

  const fetchPartnerRoles = useCallback(async () => {
    try {
      const response = await getPartnerRoles();
      if (response.status == 200) {
        setAllRoles(response.data?.result);
        setIsLoading(false);
      } else {
        setToast(response?.message, "error");
        setIsLoading(false);
      }
    } catch (err) {
      console.log("Error ->", err);
      setToast(response?.message, "error");
      setIsLoading(false);
    }
  },[setAllRoles])

  const fetchPartnerUsers = useCallback(async () => {
    try {
      const response = await getPartnerUsers();
      if (response.status == 200) {
        setUserData(response.data?.result);
        setUserDataCopy(response.data?.result)
      } else {
        setToast(response?.message, "error");
      }
    } catch (err) {
      console.log("Error ->", err);
      setToast(response?.message, "error");
    }
  }, [setUserDataCopy, setUserData]);

  useEffect(() => {
    fetchPartnerRoles();
    fetchPartnerUsers();
  }, []);

  const breadCrumb = [
    {
      label: "Admin",
      path: "/admin",
    },
    {
      label: "Users",
      path: "/admin/users",
    },
  ];

  const handleFilter = (id: string | number) => {
    if(id !== "ALL"){
    let usersList = userDataCopy.filter(((val: any) => val.profileId == id))
    if(search){
      let searchedData = usersList.filter(
        (item: any) => {
          let fullName: any;
          if (item.name && item.lastName) {
            fullName = `${item.name} ${item.lastName}`.toLowerCase();
          } else if (item.name) {
            fullName = `${item.name}`.toLowerCase();
          }
          return fullName.toLowerCase().includes(search) ||
            (item?.mobile?.includes(search)) ||
            (item?.mailId?.toLowerCase()?.includes(search))
        }
      );
      setUserData(usersList)
    } else {
      setUserData(usersList)
    }
    } else {
      setUserData(userDataCopy)
    }
  };

  const handleChangeSwitch =
    (userId: string, type: string) => async (event: any) => {
      const checked = event.target.checked;
      const updatedStatus = checked ? "ACTIVE" : "SUSPENDED";
      let payload = {
        userid: userId,
      };

      try {
        const response = await ActivateAndSuspenduser(type, payload);
        if (response?.status == 200) {
          const newData = [...setData];
				  const userIndex = newData.findIndex(user => user.userId === userId);
          
          newData[userIndex].accountStatus = updatedStatus;
          setUserData(newData);
          fetchPartnerUsers();
          setToast(response.data?.message, "success");
        } else {
          setToast(response.data?.message, "error");
        }
      } catch (err) {
        console.log("Error ->", err);
        setToast("API ERROR updating account status", "error");
      }
    };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target?.value?.toLowerCase();
    setSearch(val);
  };

  const handleToggleDropdown = (id: any) => {
    setDropdownVisible((prevId) => (prevId === id ? null : id));
  };

  const openAddModal = () => {
    setOpenModal1(true);
  };

  const openDeleteModal = (id: any) => {
    setConfirmationModalOpen(true);
    setUserDeleteId(id);
  };
  const openEditModal = (userId: any) => {
    const userInfo: any = setData.find((data) => data?.userId === userId);
    let roleName: any = allRoles.find(
      (res) => res?.profileId === userInfo?.profileId
    );

    setOpenModal2(true);
    setEditFormData({
      userId: userInfo.userId,
      name: userInfo.name,
      lastName: userInfo.lastName,
      mailId: userInfo.mailId,
      mobile: userInfo.mobile,
      profileId: userInfo.profileId,
      redirecturl: "",
      profileName: roleName?.profileName,
    });
    setSelectedRole(roleName?.profileName);
  };

  const handleCloseModal = () => {
    setOpenModal1(false);
    setOpenModal2(false);
    setOpenModal3(false);
    setFormData({
      name: "",
      lastName: "",
      mailId: "",
      mobile: "",
      profileId: 0,
      emailMessage: "",
      profileName: "",
      redirecturl: "/set-password?uk=",
    });
    setEditFormData({
      name: "",
      lastName: "",
      mailId: "",
      mobile: "",
      profileId: 0,
      userId: "",
      emailMessage: "",
      profileName: "",
    });
    let errors: Partial<FormData> = {};
    setErrors(errors);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "name") {
      errors.name = "";
    } else if (name === "lastName") {
      errors.lastName = "";
    } else if (name === "mobile") {
      errors.mobile = "";
    } else if (name === "mailId") {
      if (!emailPattern.test(value)) {
        errors.mailId = "Please provide correct email pattern";
      } else {
        errors.mailId = "";
      }
    }

    else if (name === "profile") {
      errors.emailMessage = "";
    }

    if (openModal2) {
      setEditFormData({ ...editFormData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleNumber = (number: any, trimmedNumber: any, type: string) => {
    if (type === "create") {
      setFormData({ ...formData, mobile: number });
    } else {
      setEditFormData({ ...editFormData, mobile: number });
    }
    validatePhoneNumber(trimmedNumber);
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    // This pattern allows an optional + followed by 10 to 15 digits, covering most international formats.
    const phonePattern = /^\+?\d{10,15}$/;

    if (!phonePattern.test(phoneNumber)) {
      setPhoneNumber((prev) => ({
        ...prev,
        number: phoneNumber,
        error: "Invalid phone number",
      }));
      setErrors((prev) => ({
        ...prev,
        mobile: "Invalid phone number",
      }));
    } else {
      setPhoneNumber((prev) => ({
        ...prev,
        number: phoneNumber,
        error: "",
      }));
      setErrors((prev) => ({
        ...prev,
        mobile: "",
      }));
    }
  };

  const toggleRolesDropdown = () => {
    setRolesVisible(!rolesVisible);
  };

  const handleAllCheckBox = (e: any) => {
    const newCheckedIds: string[] = [];
    if (e.target.checked) {
      setData.filter((item: any) => {
        setCheckedItems((prevState) => ({
          ...prevState,
          [item.userId]: !prevState[item.userId],
        }));
        newCheckedIds.push(item.userId);
      });
      setCheckedAllUser(true);
      setSelectedCount(setData.length);
      setCheckedIds((prevCheckedIds) => [...prevCheckedIds, ...newCheckedIds]);
    } else {
      setSelectedCount(0);
      setCheckedItems({});
      setCheckedIds([]);
      setCheckedAllUser(false);
    }
  };

  const isActiveUserMatch = () => {
    if (!searchQuery) return true;

    let fullName = "";
    if (activeUser.name && activeUser.lastName) {
      fullName = `${activeUser.name} ${activeUser.lastName}`.toLowerCase();
    } else if (activeUser.name) {
      fullName = activeUser.name.toLowerCase();
    }

    return (
      fullName.includes(searchQuery) ||
      (activeUser?.phone && activeUser?.phone?.includes(searchQuery)) ||
      (activeUser?.email &&
        activeUser?.email?.toLowerCase()?.includes(searchQuery))
    );
  };

  const handleCheckboxChange = (id: string) => {
    const newCheckedItems = { ...checkedItems, [id]: !checkedItems[id] };
    setCheckedItems(newCheckedItems);
    const count = Object.values(newCheckedItems).filter(Boolean).length;
    if (count === setData.length) {
      setCheckedAllUser(true);
    } else {
      setCheckedAllUser(false);
    }
    setSelectedCount(count);
    if (checkedIds.includes(id)) {
      const updatedIds = checkedIds.filter((checkedId) => checkedId !== id);
      setCheckedIds(updatedIds);
    } else {
      setCheckedIds([...checkedIds, id]);
    }
  };
  const handleModalTabClick = (tab: any) => {
    setActiveModalTab(tab);
  };

  const handleUsernameClick = (id: any) => {
    handleCheckboxChange(id);
  };

  const getRoleNameByProfileId = (id: number) => {
    let a = allRoles.find((role) => role.profileId === id);
    if (a) {
      return a.profileName;
    } else {
      return "N/A";
    }
  };

  const handleRoleChange = (name: string, id: number) => {
    setSelectedRole(name);
    if (openModal2) {
      const updatedFormData = {
        ...editFormData,
        profileId: id,
        profileName: name,
      };
      setEditFormData(updatedFormData);
    } else {
      const updatedFormData = {
        ...formData,
        profileId: id,
        profileName: name,
      };
      setFormData(updatedFormData);
    }
    errors.profileId = "";
  };

  const handleSubmit = async (e: any, type: string) => {
    e.preventDefault();
    let payload = {};
    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      let payloadData = { ...formData, redirecturl: `/set-password?uk=` };

      if (formData.mobile.trim() !== "") {
        payloadData.mobile = `+${formData.mobile}`;
      }
      payload = [payloadData];
      const response = await addBulkPartnerUsers(payload);
      if (response?.status === 200) {
        setToast("User updated successfully!", "success");
        setOpenModal1(false);
        fetchPartnerUsers();
        setFormData({
          name: "",
          lastName: "",
          mailId: "",
          mobile: "",
          profileId: 0,
          emailMessage: "",
          redirecturl: "",
          profileName: ""
        });
        setSelectedRole("")
      } else {
        setToast(response?.data?.message, "error");
      }
    }
  };

  const handleUpdate = async (e: any, type: string) => {
    e.preventDefault();
    let payload = {};
    const validationErrors = validateForm(editFormData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      let payloadData = { ...editFormData, redirecturl: `/set-password?uk=` };

      if (formData.mobile.trim() !== "") {
        payloadData.mobile = editFormData.mobile.startsWith("+")
          ? editFormData.mobile
          : `+${editFormData.mobile}`;
      }
      var form_data = new FormData();
      form_data.append("name", editFormData.name);
      form_data.append("lastname", editFormData.lastName);
      form_data.append("email", editFormData.mailId);
      form_data.append("profileId", editFormData.profileId);
      form_data.append(
        "mobile",
        editFormData.mobile.startsWith("+")
          ? editFormData.mobile
          : `+${editFormData.mobile}`
      );
      form_data.append("redirecturl", `/set-password?uk=`);
      payload = form_data;

      const response = await updatePartnerUsers(editFormData.userId, payload);
      if (response?.status === 200) {
        setToast("User updated successfully!", "success");
        setOpenModal2(false);
        fetchPartnerUsers();
        setEditFormData({
          name: "",
          lastName: "",
          mailId: "",
          mobile: "",
          profileId: 0,
          emailMessage: "",
          redirecturl: "",
          profileName: "",
        });
        setSelectedRole("")
      } else {
        setToast(response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (isDeleting) deleteUser(userDeleteId);
  }, [isDeleting]);

  const deleteUser = async (id: string) => {
    var payload: string[] = [];
    if(isDeleting) {
      payload.push(id)
    } 
    const response = await deletePartnerUsers(payload);
    if (response?.status === 200) {
      setIsDeleting(false);
      setToast(response?.data?.message, "success");
      fetchPartnerUsers()
    } else {
      setToast(response?.data?.message, "error");
    }
  };

  const styleModal = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: "650px",
    backgroundColor: "#1D292E",
    border: "1px solid #5A5F60",
    borderRadius: "32px",
    padding: "32px",
  };


  const displayFullName = (firstName: string, lastName: string) => {
    let fullName = firstName + " " + lastName;

    if (fullName.length > 30) {
      fullName = fullName.slice(0, 30) + "...";
    }
    return fullName;
  };



  const displayEmail = (email: string) => {
    if (email.length > 30) {
      email = email.slice(0, 30) + "...";
    }
    return email;
  };



  return (
    <Box>
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        style={{ paddingBottom: "32px" }}
      >
        <div></div>
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="16px"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              className="integrations-search"
              sx={{ width: "100%", maxWidth: "400px" }}
            >
              <img src={searchIcon} alt="Search Icon" className="icon" />
              <input
                placeholder="Search"
                onChange={handleSearch}
                style={{ width: "260px" }}
                value={search}
              />
            </Box>
          </div>
          <FormControl
            fullWidth
            variant="standard"
            className={classes.formControl}
          >
            <Select
              defaultValue={"ALL"}
              sx={{
                "&:hover:not(.Mui-disabled, .Mui-error):before": {
                  borderBottom: "none",
                },
                "&:focus:not(.Mui-disabled, .Mui-error):before": {
                  borderBottom: "none",
                },
                "&:before": {
                  borderBottom: "none",
                },
                "&.Mui-focused:after": {
                  borderBottom: "none",
                },
              }}
              inputProps={{
                MenuProps: {
                  PaperProps: {
                    sx: {
                       backgroundColor: '#1F2F34 !important'
                    }
                  }
                }
              }}
            >
              <MenuItem
                value={"ALL"}
                className={classes.menuItem}
                onClick={() => handleFilter("ALL")}
              >
                All Roles
              </MenuItem>

              {allRoles.map((role: any, index: number) => (
                <MenuItem
                  key={index}
                  value={role.profileId}
                  className={classes.menuItem}
                  onClick={() => handleFilter(role.profileId)}
                >
                  {role.profileName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(e, value) => setView(value)}
            className={classes.toggleBtnsGrp}
          >
            <ToggleButton
              value="grid"
              className={
                activeTab === "grid" ? "toggle-switch active" : "toggle-switch"
              }
              onClick={() => handleTabClick("grid")}
            >
              <img src={gridIcon} alt="grid icon" />
            </ToggleButton>
            <ToggleButton
              value="table"
              className={
                activeTab === "table" ? "toggle-switch active" : "toggle-switch"
              }
              onClick={() => handleTabClick("table")}
            >
              <img src={listIcon} alt="list icon" />
            </ToggleButton>
          </ToggleButtonGroup>

          <button className="add-btn" onClick={openAddModal} style={{cursor: "pointer"}}>
            Add New User
          </button>
        </Stack>
      </Stack>
      <Box
        style={
          {
            position: "relative",
            height: "calc(100vh - 150px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          } as any
        }
      >
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100%)",
            }}
          >
            <Loading />
          </Box>
        ) : (
          <>
            {activeTab === "grid" && (
              <Grid
                container
                spacing={2}
                style={
                  {
                    position: "relative",
                    "-ms-overflow-style": "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                  } as any
                }
              >
                {setData
                  .filter((userData) =>
                    userData?.name?.toLowerCase()?.includes(search.toLowerCase()) 
                    || userData?.lastName?.toLowerCase()?.includes(search.toLowerCase())
                    || userData?.mailId?.toLowerCase()?.includes(search.toLowerCase())
                    || userData?.mobile?.includes(search)
                  )
                  ?.map((user, index) => (
                    <Grid size={{ xs: 12, md: 6, lg: 3 }} key={user.userId}>
                      <UserCardGrid
                        index={index}
                        user={user}
                        key={index}
                        handleChangeSwitch={handleChangeSwitch(
                          user.userId,
                          user.accountStatus === "ACTIVE"
                            ? "suspend"
                            : "activate"
                        )}
                        checked={user.accountStatus === "ACTIVE" ? true : false}
                        openEditModal={(userId) => openEditModal(userId)}
                        openDeleteModal={() => openDeleteModal(user.userId)}
                        allRoles={allRoles}
                      />
                    </Grid>
                  ))}
              </Grid>
            )}
          </>
        )}
        {/* TABLE VIEW  */}
        {activeTab === "table" && (
          <TableContainer
            style={{
              position: "relative",
              height: "calc(100vh - 170px)",
              overflowY: "auto",
            }}
          >
            <Table className={`userTable ${classes.userTableBG}`}>
              <TableHead style={{ borderBottom: "2px solid #5A5F60" }}>
                <TableRow>
                  <TableCell className="tableHeading">
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkedAllUser}
                          className={classes.checkbox}
                          onChange={handleAllCheckBox}
                        />
                      }
                      label={<Typography>User Name</Typography>}
                    /> */}
                    User Name
                  </TableCell>
                  <TableCell className="tableHeading">User ID</TableCell>
                  <TableCell className="tableHeading">Contact Number</TableCell>
                  <TableCell className="tableHeading">User Role</TableCell>
                  <TableCell className="tableHeading">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {setData
                .filter((userData) =>
                  userData?.name?.toLowerCase()?.includes(search.toLowerCase()) 
                  || userData?.lastName?.toLowerCase()?.includes(search.toLowerCase())
                  || userData?.mailId?.toLowerCase()?.includes(search.toLowerCase())
                  || userData?.mobile?.includes(search)
                  // || userData?.lastName?.toLowerCase()?.includes(search.toLowerCase())
                )
                ?.map((user, index) => (
                  <TableRow
                    key={user.userId}
                    style={{
                      opacity: user.accountStatus === "ACTIVE" ? "1" : "0.4",
                    }}
                  >
                    <TableCell className="tableData">
                      <Stack
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        gap="16px"
                      >
                        {/* <Checkbox
                          checked={checkedItems[user.userId] || false}
                          onChange={() => handleCheckboxChange(user.userId)}
                          className={classes.checkbox}
                          disabled={user.accountStatus !== "ACTIVE"}
                        /> */}
                        {user.profilePhoto ? (
                          <img
                            src={user.profilePhoto}
                            alt="user"
                            className="icon"
                            height={52}
                            width={52}
                          />
                        ) : (
                          <ProfileAvatar
                            firstName={user.name}
                            lastName={user.lastName}
                          />
                        )}
                        <span
                          onClick={() => handleUsernameClick(user.userId)}
                          style={{ cursor: "pointer" }}
                        >
                          <InfoHoverTooltip title={user.name + " " + user.lastName} arrowDirection="top">
                            {displayFullName(user.name, user.lastName)}
                          </InfoHoverTooltip>
                        </span>
                      </Stack>
                    </TableCell>
                    <TableCell className="tableData">
                      <InfoHoverTooltip title={user.mailId} arrowDirection="top">
                        {displayEmail(user.mailId)}
                      </InfoHoverTooltip>
                    </TableCell>
                    <TableCell className="tableData">{user.mobile}</TableCell>
                    <TableCell className="tableData">
                      {getRoleNameByProfileId(user.profileId)}
                    </TableCell>
                    <TableCell className="tableData">
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Box
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          paddingRight="19px"
                          borderRight={
                            user.accountStatus === "ACTIVE"
                              ? "1px solid #313838"
                              : ""
                          }
                          margin="3px 0px"
                        >
                          {/* <InfoHoverTooltip
                              title={user.accountStatus === "ACTIVE" ? "Suspend" : "Activate"}
                              arrowDirection="bottom"
                            > */}
                          <FormControlLabel
                            control={
                              <AntSwitch
                                checked={
                                  user.accountStatus === "ACTIVE" ? true : false
                                }
                                onClick={handleChangeSwitch(
                                  user.userId,
                                  user.accountStatus === "ACTIVE"
                                    ? "suspend"
                                    : "activate"
                                )}
                                inputProps={{ "aria-label": "ant design" }}
                              />
                            }
                            label={""}
                          />
                          {/* </InfoHoverTooltip> */}
                        </Box>

                        {user.accountStatus === "ACTIVE" && (
                          <InfoHoverTooltip
                          title={"Edit"}
                          arrowDirection="bottom"
                          >
                          <img
                            src={editIcon}
                            alt="edit icon"
                            className="icon"
                            onClick={() => openEditModal(user.userId)}
                          />
                           </InfoHoverTooltip>
                        )}
                        {user.accountStatus === "ACTIVE" && (
                          <InfoHoverTooltip
                          title={"Delete"}
                          arrowDirection="bottom"
                          >
                          <img
                            src={deleteIcon}
                            alt="delete icon"
                            className="icon"
                            onClick={() =>
                              openDeleteModal(user.userId)
                            }
                          />
                          </InfoHoverTooltip>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      {/* ADD NEW USER FORMS  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal1}
        onClose={handleCloseModal}
        closeAfterTransition
        className="customMuiModal"
      >
        <Fade in={openModal1}>
          <Box sx={styleModal}>
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              style={{
                borderBottom: "1px solid #5A5F60",
                paddingBottom: "15px",
                marginBottom: "40px",
              }}
            >
              <Typography className="modalHeading">Add New User</Typography>
              <img
                src={closeIcon}
                alt="close icon"
                onClick={handleCloseModal}
                className="icon"
              />
            </Stack>
            <Box>
                <div>
                  {
                    <form
                      style={
                        {
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          "-ms-overflow-style": "none",
                          "&::-webkit-scrollbar": {
                            display: "none",
                          },
                        } as any
                      }
                    >
                      <Stack
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        sx={{
                          marginBottom: "20px",
                        }}
                      >
                        <Box
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{ display: "flex", width: "100%", gap: "16px" }}
                          >
                            <div style={{ width: "50%", position: "relative" }}>
                              <label
                                htmlFor="firstName"
                                className="modalFormLabel"
                              >
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                id="firstName"
                                placeholder="Enter First Name "
                                className={`modalForm-input`}
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                            <div style={{ width: "50%" }}>
                              <label
                                htmlFor="lastName"
                                className="modalFormLabel"
                              >
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>{" "}
                              <input
                                type="text"
                                id="lastName"
                                placeholder="Enter Last Name "
                                name="lastName"
                                className={`modalForm-input`}
                                value={formData.lastName}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                          </Box>
                          {(errors.name || errors.lastName) && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              First and last name can't be empty
                            </div>
                          )}
                        </Box>
                      </Stack>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="emailId" className="modalForm-label">
                            Email ID <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <input
                            type="email"
                            id="emailId"
                            name="mailId"
                            placeholder="Enter Email ID "
                            className={`modalForm-input`}
                            value={formData.mailId}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </Box>
                        {errors.mailId && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.mailId}
                          </div>
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="contact" className="modalFormLabel">
                            Mobile Number{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <PhoneInput
                            specialLabel=""
                            value={formData.mobile}
                            onChange={(number, country) => {
                              // @ts-ignore
                              const countryCode = country?.dialCode;
                              const trimmedNumber = number.startsWith(
                                countryCode
                              )
                                ? number.slice(countryCode.length)
                                : number;

                              handleNumber(number, trimmedNumber, "create");
                            }}
                            country="us"
                            dropdownClass="user-phone-input-dropdown"
                            containerClass="user-phone-input-container"
                            containerStyle={{
                              marginTop: "12px",
                            }}
                            inputClass={`modalForm-input user-phone-input`}
                            inputStyle={{
                              boxShadow: "none",
                              color: "#fff",
                              border: "1px solid #313838 !important",
                              width: "100%",
                              height: "40px",
                              backgroundColor: "transparent",
                            }}
                          />
                          {errors.mobile && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              {errors.mobile}
                            </div>
                          )}
                        </Box>
                      </Box>

                      <div
                        style={{ marginBottom: "24px", position: "relative" }}
                      >
                        <label htmlFor="rolesBox" className="modalFormLabel">
                          Assign Role <span style={{ color: "red" }}>*</span>
                        </label>{" "}
                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          className={`${
                            errors.profileId ? "errors" : ""
                          } modalForm-input`}
                          style={{
                            marginBottom: "-10px",
                            cursor: "pointer",
                          }}
                          onClick={toggleRolesDropdown}
                        >
                          <span className="selectedValue">
                            {selectedRole || "Select Role"}
                          </span>
                          <ExpandMoreIcon
                            sx={{
                              cursor: "pointer",
                              color: "#B4B7B8",
                              fontSize: "24px",
                              display: "inline-block",
                              transition: "0.5s",
                            }}
                          />
                        </Stack>
                        {rolesVisible && (
                          <ClickAwayListener
                            onClickAway={() => setRolesVisible(false)}
                          >
                            <div
                              className="modalForm-menu"
                              id="sitesBox"
                              style={{
                                position: "absolute",
                                width: "100%",
                                maxHeight: "210px",
                                overflow: "auto",
                                scrollbarWidth: "none",
                                zIndex: 9,
                              }}
                            >
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  name="radio-buttons-group"
                                  value={selectedRole}
                                >
                                  {allRoles.map((role, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={role.profileName}
                                      control={
                                        <Radio className={classes.radio} />
                                      }
                                      label={role.profileName}
                                      onClick={() => {
                                        handleRoleChange(
                                          role.profileName,
                                          role?.profileId
                                        );
                                        setRolesVisible(() => false);
                                      }}
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </ClickAwayListener>
                        )}
                        {errors.profileId && (
                          <div className="dropdown-error-message">
                            {errors.profileId}
                          </div>
                        )}
                      </div>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label
                            htmlFor="emailMessage"
                            className="modalFormLabel"
                          >
                            Email Message (optional)
                          </label>
                          <input
                            type="email"
                            id="emailMessage"
                            name="emailMessage"
                            placeholder="Enter Email Message "
                            className={`modalForm-input`}
                            value={formData.emailMessage}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          {errors.emailMessage && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              {errors.emailMessage}
                            </div>
                          )}
                        </Box>
                      </Box>
                    </form>
                  }
                </div>

                {
                  <div>
                    <Stack
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="flex-end"
                      gap="12px"
                    >
                      <button
                        type="button"
                        className="outline-btn-disable"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="add-btn save-btn"
                        onClick={(e) => handleSubmit(e, "user")}
                        // disabled={isDisabled}
                      >
                        Save
                      </button>
                    </Stack>
                  </div>
                }
            </Box>
          </Box>
        </Fade>
      </Modal>

      {/* EDITUSER FORMS  */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal2}
        onClose={handleCloseModal}
        closeAfterTransition
        className="customMuiModal"
      >
        <Fade in={openModal2}>
          <Box sx={styleModal}>
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              style={{
                borderBottom: "1px solid #5A5F60",
                paddingBottom: "15px",
                marginBottom: "40px",
              }}
            >
              <Typography className="modalHeading">Edit User</Typography>
              <img
                src={closeIcon}
                alt="close icon"
                onClick={handleCloseModal}
                className="icon"
              />
            </Stack>
            <Box>
              <div>
                <div>
                  {
                    <form
                      style={
                        {
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          "-ms-overflow-style": "none",
                          "&::-webkit-scrollbar": {
                            display: "none",
                          },
                        } as any
                      }
                    >
                      <Stack
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        sx={{
                          marginBottom: "20px",
                        }}
                      >
                        <Box
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            sx={{ display: "flex", width: "100%", gap: "16px" }}
                          >
                            <div style={{ width: "50%", position: "relative" }}>
                              <label
                                htmlFor="firstName"
                                className="modalFormLabel"
                              >
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>{" "}
                              <input
                                type="text"
                                id="firstName"
                                placeholder="Enter First Name "
                                className={`modalForm-input`}
                                name="name"
                                value={editFormData.name}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                            <div style={{ width: "50%" }}>
                              <label
                                htmlFor="lastName"
                                className="modalFormLabel"
                              >
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>{" "}
                              <input
                                type="text"
                                id="lastName"
                                placeholder="Enter Last Name "
                                name="lastName"
                                className={`modalForm-input`}
                                value={editFormData.lastName}
                                onChange={handleChange}
                                autoComplete="off"
                              />
                            </div>
                          </Box>
                          {(errors.name || errors.lastName) && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              First and last name can't be empty
                            </div>
                          )}
                        </Box>
                      </Stack>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="emailId" className="modalForm-label">
                            Email ID <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <input
                            type="email"
                            id="emailId"
                            name="mailId"
                            placeholder="Enter Email ID "
                            className={`modalForm-input`}
                            value={editFormData.mailId}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </Box>
                        {errors.mailId && (
                          <div
                            className="error-message"
                            style={{ paddingTop: "6px" }}
                          >
                            {errors.mailId}
                          </div>
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "20px",
                        }}
                      >
                        <Box>
                          <label htmlFor="contact" className="modalFormLabel">
                            Mobile Number{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>{" "}
                          <PhoneInput
                            specialLabel=""
                            value={editFormData.mobile}
                            onChange={(number, country) => {
                              // @ts-ignore
                              const countryCode = country?.dialCode;
                              const trimmedNumber = number.startsWith(
                                countryCode
                              )
                                ? number.slice(countryCode.length)
                                : number;

                              handleNumber(number, trimmedNumber, "edit");
                            }}
                            country="us"
                            dropdownClass="user-phone-input-dropdown"
                            containerClass="user-phone-input-container"
                            containerStyle={{
                              marginTop: "12px",
                            }}
                            inputClass={`modalForm-input user-phone-input`}
                            inputStyle={{
                              boxShadow: "none",
                              color: "#fff",
                              border: "1px solid #313838 !important",
                              width: "100%",
                              height: "40px",
                              backgroundColor: "transparent",
                            }}
                          />
                          {errors.mobile && (
                            <div
                              className="error-message"
                              style={{ paddingTop: "6px" }}
                            >
                              {errors.mobile}
                            </div>
                          )}
                        </Box>
                      </Box>

                      <div
                        style={{ marginBottom: "24px", position: "relative" }}
                      >
                        <label htmlFor="rolesBox" className="modalFormLabel">
                          Assign Role
                        </label>{" "}
                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="space-between"
                          className={`${
                            errors.profileId ? "errors" : ""
                          } modalForm-input`}
                          style={{
                            marginBottom: "-10px",
                            cursor: "pointer",
                          }}
                          onClick={toggleRolesDropdown}
                        >
                          <span className="selectedValue">
                            {selectedRole || "Select Role"}
                          </span>
                          <ExpandMoreIcon
                            sx={{
                              cursor: "pointer",
                              color: "#B4B7B8",
                              fontSize: "24px",
                              display: "inline-block",
                              transition: "0.5s",
                            }}
                          />
                        </Stack>
                        {rolesVisible && (
                          <ClickAwayListener
                            onClickAway={() => setRolesVisible(false)}
                          >
                            <div
                              className="modalForm-menu"
                              id="sitesBox"
                              style={{
                                position: "absolute",
                                width: "100%",
                                maxHeight: "180px",
                                overflow: "auto",
                                scrollbarWidth: "none",
                                zIndex: 9,
                              }}
                              ref={(dropdown) => {
                                if (dropdown) {
                                  dropdown.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                                }
                              }}
                            >
                              <FormControl>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  name="radio-buttons-group"
                                  value={selectedRole}
                                >
                                  {allRoles.map((role, index) => (
                                    <FormControlLabel
                                      key={index}
                                      value={role.profileName}
                                      control={
                                        <Radio className={classes.radio} />
                                      }
                                      label={role.profileName}
                                      onClick={() => {
                                        handleRoleChange(
                                          role.profileName,
                                          role?.profileId
                                        );
                                        setRolesVisible(() => false);
                                      }}
                                    />
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </ClickAwayListener>
                        )}
                        {errors.profileId && (
                          <div className="dropdown-error-message">
                            {errors.profileId}
                          </div>
                        )}
                      </div>
                    </form>
                  }
                </div>

                {

                    <Stack
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="flex-end"
                      gap="12px"
                      sx={{
                        marginTop: rolesVisible ? "16px" : "0px"
                      }}
                    >
                      <button
                        type="button"
                        className="outline-btn-disable"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="add-btn save-btn"
                        onClick={(e) => handleUpdate(e, "user")}
                        // disabled={isDisabled}
                      >
                        Save
                      </button>
                    </Stack>

                }
              </div>
            </Box>
          </Box>
        </Fade>
      </Modal>

      <ConfirmationModal
        open={confirmationModalOpen}
        title="Delete User"
        message={
          "Are you sure you want to delete this user? This action cannot be undone."
        }
        setConfirmation={setIsDeleting}
        setConfirmationModalOpen={setConfirmationModalOpen}
      />
    </Box>
  );
};

export default UsersTab;
